// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateEdgeInfo_wrapper__cf9p1"};